import api from '../../../api/endpoints';
import { sessionCache, sessionCached } from '../../../utils/cache';
import { dataFetch } from '../../../api/data-fetch';
import config from '../config';
import t from './types';

const init = async ({ commit, dispatch }, [hash, eventId, eventRunners]) => {
  dispatch('FormFinder/fetchFields', hash);

  if (eventId) {
    commit(t.EVENT_FILTER, eventId);
  }
  if (eventRunners) {
    commit(t.EVENT_RUNNERS, eventRunners);
  }
  if (hash) {
    dispatch('FormFinder/fetchResults', hash);
  } else {
    commit(t.STATUS, t.STARTED);
  }
};

const fetchFields = async ({ commit }, hash = null) => {
  let fieldsData;

  if (hash || !(fieldsData = sessionCached('FF/fields'))) {
    const params = {};
    if (hash) params.hash = hash;
    fieldsData = await dataFetch(api.FORM_FINDER_FIELDS, { params });
    sessionCache('FF/fields', fieldsData, config.cacheTime);
  }

  commit(t.FIELDS, fieldsData);
  commit(t.INFO, fieldsData.info);
  commit(t.PRESETS, fieldsData.presets);
  commit(t.TOTAL_COUNT, [fieldsData.totalUpcomingSelections, fieldsData.dayRange]);
};

const fetchResults = async ({ commit, dispatch, getters }, hash) => {
  let eventFilter, results;
  const url = `${api.FORM_FINDER}`;
  const metrics = getters['FormFinder/metrics'];
  const activeMetrics = getters['FormFinder/fields'].map(field => field.metric);
  const queryFilters = Object.values(metrics)
    .filter(metric => {
      return metric.value !== 0 && activeMetrics.includes(metric.id);
    })
    .map(metric => {
      return {
        name: metric.setting,
        metric: metric.name,
        value: metric.value,
        range: metric.range,
      };
    });
  const queryParam = JSON.stringify({
    filters: queryFilters,
  });
  const params = hash ? { hash } : { q: queryParam };
  if ((eventFilter = getters['FormFinder/eventFilter'])) {
    params.events = eventFilter;
  }

  if (!queryFilters.length && !hash) {
    commit(t.STATUS, t.STARTED);
    return;
  }

  commit(t.STATUS, t.FETCH_RESULTS);
  commit(t.QUERY, queryParam);

  const cacheKey = JSON.stringify(params);

  if (!(results = sessionCached(`FF/${cacheKey}`))) {
    // new search
    try {
      results = await dataFetch(url, { params });
      sessionCache(`FF/${cacheKey}`, results, config.cacheTime);
    } catch (error) {
      commit(t.STATUS, t.ERROR_FETCH);
    }
  }

  return new Promise(resolve => {
    if (!results) return resolve();

    if (getters['FormFinder/query'] === queryParam) {
      commit(t.HASH, results.hash);
      commit(t.RESULTS, { events: results.events, hash: results.hash });
      commit(t.STATUS, results.events.length ? t.RESULTS : t.RESULTS_NONE);

      dispatch('BestOdds/fetchEventOdds', results.events.map(event => event.id));

      return resolve(results.hash);
    }

    return resolve();
  });
};

const updateFilter = ({ commit }, payload) => {
  if (payload && payload.length) {
    commit(t.FIELD, payload);
  }
};

const search = async ({ dispatch }, hash = null) => {
  // if hash given, need to refresh form filters
  if (hash) {
    dispatch('FormFinder/fetchFields', hash);
  }
  return await dispatch('FormFinder/fetchResults', hash);
};

export default { init, fetchFields, fetchResults, search, updateFilter };
